import React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
const VelourButton = styled(Button)({
  fontFamily: 'Cormorant Garamond, serif',
  fontWeight: 600,
  fontSize: '1.1rem',
  letterSpacing: '0.1em',
  textTransform: 'none',
  color: '#e2c4cc',
  background: `linear-gradient(180deg, rgba(72, 22, 44, 0.92) 0%, rgba(44, 10, 28, 0.96) 100%), 
  radial-gradient(ellipse at 50% -20%, rgba(186, 151, 169, 0.28), transparent 72%)`,
  border: '1px solid rgba(175, 80, 115, 0.32)',
  borderRadius: '50px',
  padding: '14px 36px',
  minWidth: '65%',
  margin: '6px auto',
  display: 'flex',
  justifyContent: 'center',
  boxShadow: 'inset 0 1px 0 rgba(230, 170, 200, 0.1), 0 5px 22px rgba(0, 0, 0, 0.55)',
  transition: 'transform 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease',
  '&:hover': {
    transform: 'scale(1.025)',
    borderColor: 'rgba(205, 105, 140, 0.5)',
    boxShadow: 'inset 0 1px 0 rgba(240, 185, 210, 0.15), 0 7px 26px rgba(0, 0, 0, 0.62)',
  },
});

const DrinkButton = styled(Button)({
  position: 'relative',
  overflow: 'hidden',
  justifyContent: 'center',
  alignItems: 'center',
  border: '1px solid rgba(160, 55, 110, 0.28)',
  background: `
    radial-gradient(ellipse at 50% 0%, rgba(160, 55, 120, 0.18), transparent 65%),
    linear-gradient(to bottom, #2e0f20 0%, #1e0916 55%, #160710 100%)
  `,
  color: '#d48aae',
  fontSize: '1.05rem',
  fontFamily: 'Playfair Display, serif',
  fontWeight: 500,
  letterSpacing: '0.09em',
  textTransform: 'none',
  borderRadius: '50px',
  padding: '13px 36px',
  margin: '5px',
  marginTop: '10px',
  width: '75%',
  maxWidth: '300px',
  cursor: 'pointer',
  boxShadow: '0 0 18px rgba(140, 40, 95, 0.18), 0 4px 14px rgba(0, 0, 0, 0.55)',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    transform: 'scale(1.03)',
    boxShadow: '0 0 24px rgba(155, 50, 110, 0.28), 0 4px 16px rgba(0, 0, 0, 0.6)',
  },
  '&.Mui-disabled': {
    color: '#a07888',
    opacity: 1,
    background: `
      radial-gradient(ellipse at 50% 0%, rgba(100, 35, 75, 0.1), transparent 65%),
      linear-gradient(to bottom, #1e0a14 0%, #140810 100%)
    `,
    border: '1px solid rgba(140, 55, 90, 0.18)',
    boxShadow: 'none',
  },
});
// Styled MUI Button with your custom CSS baked in
const StyledButton = styled(Button)(({ theme }) => ({
  fontFamily: 'Playfair Display, serif',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '1.2rem',
  color: '#ffbfe5',
  backgroundColor: 'rgba(16, 14, 29, 0.75)',
  border: '1.5px solid rgba(206, 94, 176, 0.4)',
  boxShadow: '0 0 3px rgba(228, 118, 191, 0.3)',
  borderRadius: '12px',
  padding: '0',
  lineHeight: 1.3,
  maxWidth: '75%',
  margin: '5px',
  cursor: 'pointer',
  textAlign: 'center',
  position: 'relative',
  transition: 'background-color 0.3s ease, transform 0.2s ease',
  
  '&:hover': {
    backgroundColor: 'rgba(255, 191, 229, 0.247)',
    transform: 'scale(1.03)',
  },
  
  '&.Mui-disabled': {
    backgroundColor: 'rgba(80, 70, 95, 0.4)',
    color: '#aaa3aa',
    border: '1.5px solid rgba(180, 120, 170, 0.2)',
    boxShadow: 'none',
    textShadow: 'none',
    transform: 'none',
    cursor: 'not-allowed',
  },
  
  // Icon inside button, if you pass one in
  '.btn-icon': {
    position: 'absolute',
    // top: '50%',
    // transform: 'translateY(-50%)',
    right: 15,
    opacity: 0.8,
    fontSize: '1rem',
    pointerEvents: 'none',
  },
  
  '.btn-text': {
    flex: 1,
    textAlign: 'center',
    padding: '12px 20px',
  },
}));

const BaseButton = ({ children, onClick, disabled = false, icon = null, sx = {}, style = {}, ...rest}) => {
  return (
    <DrinkButton
      onClick={onClick}
      disabled={disabled}
      sx={sx}
      style={style}
      {...rest}
    >
      <span className="btn-text">{children}</span>
      {icon && <span className="btn-icon">{icon}</span>}
    </DrinkButton>
  );
};

export default BaseButton;